import { useEffect, useState } from "react";
import { api } from "../../services/apiClient";
import { useI18n } from "../../i18n/localization";
import { sortByStart, formatWhen, type Meeting } from "./scheduleView";

// Scheduled-meetings list (preference 1, design/05). POC: lists upcoming meetings with a
// Join affordance inside the join window and a Cancel action. Rendering logic is the pure
// scheduleView helpers.
export function Schedule() {
  const { t, dir } = useI18n();
  const [meetings, setMeetings] = useState<Meeting[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = () =>
    api.get<Meeting[]>("/schedule").then((m) => setMeetings(sortByStart(m))).catch((e: unknown) => setError(String(e)));

  useEffect(() => {
    void load();
  }, []);

  const cancel = async (id: number) => {
    await api.delete<void>(`/schedule/${id}`).catch(() => undefined);
    void load();
  };

  return (
    <main style={{ padding: 24, fontFamily: "Segoe UI, Arial, sans-serif", maxWidth: 720, margin: "0 auto" }} dir={dir}>
      <h1 style={{ color: "#14305f", fontSize: 19 }}>{t.schedule.title}</h1>
      {error && <div style={{ color: "#b91c1c", fontSize: 13 }}>{error}</div>}
      {meetings.length === 0 && <p style={{ color: "#5b6b82", fontSize: 14 }}>{t.schedule.none}</p>}
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {meetings.map((mtg) => (
          <li
            key={mtg.meetingId}
            style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "10px 12px", border: "1px solid #d6deea", borderRadius: 8, marginBottom: 8, background: "#fff"
            }}
          >
            <span style={{ fontSize: 14 }}>
              <strong>{formatWhen(mtg.scheduledStart)}</strong>
              <span style={{ color: "#64748b" }}> · {mtg.durationMin} {t.schedule.duration}</span>
              {mtg.caseRef && <span style={{ color: "#64748b" }}> · {t.schedule.caseRef} {mtg.caseRef}</span>}
            </span>
            <span style={{ display: "flex", gap: 8 }}>
              {mtg.joinable && (
                <a
                  href={`/?callId=0&meeting=${mtg.meetingId}`}
                  style={{ background: "#15803d", color: "#fff", borderRadius: 6, padding: "6px 16px", textDecoration: "none" }}
                >
                  {t.schedule.join}
                </a>
              )}
              <button
                onClick={() => cancel(mtg.meetingId)}
                style={{ background: "#e2e8f0", color: "#1e2a3a", border: "none", borderRadius: 6, padding: "6px 16px", cursor: "pointer" }}
              >
                {t.schedule.cancel}
              </button>
            </span>
          </li>
        ))}
      </ul>
    </main>
  );
}
